<template>
    <div>
        <div v-if="page !== 'admin'">
            <or-header @toFeedback="toFeedback"/>
            <or-content>
                <!-- <transition name="fade-out" mode="out-in"> -->
                    <or-main-page-content :settings="feedback_settings" v-if="page === 'main'" @to-feedback="toFeedback"/>
                    <or-about-page-content v-else-if="page === 'about'"/>
                    <or-production-page-content v-else-if="page === 'production'"/>
                    <or-buyers-page-content v-else-if="page === 'buyers'"/>
                    <or-news-page-content v-else-if="page === 'news'"/>
                    <or-contacts-page-content :fb_settings="feedback_settings" v-show="page === 'contacts'"/>
                <!-- </transition> -->
                
                <transition name="fade">
                    <div class="loader flex-column flex-center" v-if="!isPageReady">
                        <img class="loader-img" src="../assets/logo-loader.svg"/>
                        <p style="color: white; font-size: 14px; margin-top: 50px;">Загружаем данные...</p>
                    </div>
                </transition>
            </or-content>
            <or-footer @toFeedback="toFeedback"/>
            <img src="../assets/scroll_top.svg" class="scroll-top hover-pointer" @click="scrollTop" v-show="scroll > 500"/>
        </div>
        <or-admin-container v-if="page === 'admin'"/>
    </div>
</template>

<script>
import orHeader from './global/or-header.vue'
import orMainPageContent from './pages/or-main-page-content.vue'
import orAboutPageContent from './pages/or-about-page-content.vue'
import orProductionPageContent from './pages/or-production-page-content.vue'
import orBuyersPageContent from './pages/or-buyers-page-content.vue'
import orNewsPageContent from './pages/or-news-page-content.vue'
import orContactsPageContent from './pages/or-contacts-page-content.vue'
import orContent from './global/or-content.vue'
import orFooter from './global/or-footer.vue'
import orAdminContainer from './admin/or-admin-container.vue'
import {mapActions, mapGetters} from 'vuex'
import Axios from 'axios'

export default {
    components: {
        orHeader, 
        orMainPageContent, 
        orAboutPageContent, 
        orProductionPageContent, 
        orBuyersPageContent, 
        orNewsPageContent, 
        orContactsPageContent, 
        orContent, 
        orFooter,
        orAdminContainer},

    data() {
        return {
            ready: true,
            feedback_settings: null,
            scroll: 0,

            buyers_products_ready: false,
            buyers_ready: false,
            production_products_ready: false,
            production_ready: false,

            buyers_products: [],
            buyers_categories: [],
            production_products: [],
            production_categories: [],
        }
    },

    computed: {
        ...mapGetters({
            info: 'getInfo', 
            page: 'getPage', 
            isPageReady: 'getIsPageReady',
            getBuyers: 'getBuyers',
            getProduction: 'getProduction',
            getAbout: 'getAbout',
            getNews: 'getNews'
        }),
    },

    watch: {
        page(to) {
            window.scrollTo(0,0);
        }
    },

    beforeMount() {
        if (!this.$route.params.page) {
            this.changePage({page: 'main'});
        } else {
            this.changePage({page: this.$route.params.page});
        }

        if (this.page !== 'admin') {
            Axios.post('/api/getSiteInfo') 
                .then(({data})=>{
                    this.changeInfo({data: data})
                    setTimeout(()=>{this.changeIsPageReady({is: true})}, 200)
                })
        }
    },

    mounted() {
        window.addEventListener('scroll', (e)=>{
            this.scroll = window.pageYOffset;
        })
        if (this.$route.query.feedback) {
            this.toFeedback({focus: 'name', fill: undefined});
        }
        if (this.page !== 'admin') {
            this.getDataFromDB();
        }
    },
    methods: {
        ...mapActions({
            changeInfo: 'changeInfo', 
            changePage: 'changePage', 
            changeIsPageReady: 'changeIsPageReady',
            changeBuyers: 'changeBuyers',
            changeProduction: 'changeProduction',
            changeAbout: 'changeAbout',
            changeNews: 'changeNews',
            }),
        async getDataFromDB() {      
                

            this.getAboutFromDB();
            this.getNewsFromDB();
            await Axios.post('/api/getProducts')
                .then(({data})=>{
                    this.products = data;
                });
            await this.getBuyersFromDB();     
            await this.getProductionFromDB();     
            this.getBuyersProducts(this.products);
            this.getProductionProducts(this.products);
        },

    
        getBuyersFromDB() {
            Axios.post('/api/getBuyers')
                .then(({data})=>{
                    data.map(el=>{
                        this.buyers_categories.push({
                            id: el.id,
                            name: el.category,
                            image: el.image,
                            sort: el.sort.sort,
                        })
                    })
                    this.buyers_ready = true;
                    if (this.buyers_products_ready)  {
                        this.changeBuyers({value: {products: this.buyers_products, categories: this.buyers_categories}});
                    }
                })
        },
        getBuyersProducts(products) {
            products.map(el=>{
                this.buyers_products.push({
                    content: el.content,
                    description: el.description,
                    id: el.id,
                    image: el.image,
                    name: el.name,
                    production_category_id: el.production_category_id,
                    buyers_category_id: el.buyers_category_id,
                })
            })
            this.buyers_products_ready = true;
            if (this.production_ready) {
                this.changeBuyers({value: {products: this.buyers_products, categories: this.buyers_categories}});
            }
        },
        getProductionFromDB() {
            Axios.post('/api/getProduction')
                .then(({data})=>{
                    data.map(el=>{
                        this.production_categories.push({
                            id: el.id,
                            name: el.category,
                            image: el.image,
                            sort: el.sort.sort,
                        })
                    })
                    this.production_ready = true;
                    if (this.production_products_ready)  {
                        this.changeProduction({value: {products: this.production_products, categories: this.production_categories}});
                    }
                })
        },
        getProductionProducts(products) {
            products.map(el=>{
                this.production_products.push({
                    content: el.content,
                    description: el.description,
                    id: el.id,
                    image: el.image,
                    name: el.name,
                    production_category_id: el.production_category_id,
                    buyers_category_id: el.buyers_category_id,
                })
            })
            this.production_products_ready = true; 
            if (this.production_ready) {
                this.changeProduction({value: {products: this.production_products, categories: this.production_categories}});
            }
        },
        getAboutFromDB() {
            Axios.post('/api/getAbout')
                .then(({data})=>{
                    const options = [];
                    data.map(el=>{
                        if (el.component === 'or-admin-about-text') {
                            options.push({
                                component: 'text',
                                text: el.text.value,
                            })
                        } else {
                            options.push({
                                component: 'card',
                                text: el.text.value,
                                image: el.image,
                                image_position: el.radio.selected_variant === 0 ? 'left' : 'right'
                            })
                        }
                    })
                    this.changeAbout({value: options});
                })
        },
        getNewsFromDB() {
            Axios.post('/api/getNews')
                .then(({data})=>{
                    const all_news = [];
                    data.map(el=>{
                        all_news.push({
                            title: el.title,
                            text: el.text,
                            date: el.date,
                        })
                    });
                this.changeNews({value: all_news});
                })
        },

        toFeedback(data) {
            if (this.page !== 'contacts') {
                this.changePage({page: 'main'});
            }
            const i = setInterval(()=>{
                let f = document.getElementById('feedback');
                if (f) {
                    window.scrollTo(0, f.offsetTop);
                    clearInterval(i)
                    this.feedback_settings = data;
                }
            },10);
        },
        scrollTop() {
            window.scrollTo(0,0);
        }
    }
}
</script>

<style scoped>
    .loader {
        position: fixed;
        top: 320px;
        left: 0;
        width: 100vw;
        min-width: 1200px;
        /* max-width: 100%; */
        height: calc(100vh - 320px);
        z-index: 999999;
        background-color: black;
    }
    @keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(1080deg);}
    }
    .loader-img {
        animation-name: loader;
        animation-duration: 2s;
        animation-iteration-count: infinite;
        animation-timing-function: ease-in-out;
    }
    .scroll-top {
        position: fixed;
        right: 100px;
        bottom: 100px;
    }
    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }
    .fade-out-enter-active {
        transition: opacity 0.5s ease;
    }
    .fade-out-leave-to {
        opacity: 0;
    }
</style>